import { DpadDirection, DpadZoneType } from "@core/constants";
import { ParmaGetNextZone } from "@core/models/models";

export class DpadHelper{

  public static getNextZoneTop = (parmaGetNextZone: ParmaGetNextZone): any => {
    switch(parmaGetNextZone.currentZoneType){
      case DpadZoneType.HEADER:
        return parmaGetNextZone.configDpadZoneHeader.dYMin;
      case DpadZoneType.SUB_HEADER:
        return parmaGetNextZone.configDpadZoneSubHeader.dYMin;
      case DpadZoneType.MEMU:
        return parmaGetNextZone.configDpadZoneMenu.dYMin;
      case DpadZoneType.LOG_IN:
        return parmaGetNextZone.configDpadZoneLogin.dYMin;
      case DpadZoneType.SCREEN:
        return parmaGetNextZone.configDpadZoneScreen.dYMin;
      case DpadZoneType.TV_LAYOUT:
        return parmaGetNextZone.configDpadZoneTvLayout.dYMin;
      case DpadZoneType.TV_USER_SETTINGS_MID:
        return parmaGetNextZone.configDpadZoneTvUserSettingsMid.dYMin;
      case DpadZoneType.TV_USER_SETTINGS_RIGHT:
        return parmaGetNextZone.configDpadZoneTvUserSettingsRight.dYMin;
      case DpadZoneType.TV_USER_DB:
        return parmaGetNextZone.configDpadZoneUserDashBoard.dYMin;
      case DpadZoneType.TV_CORP_LOGIN:
        return parmaGetNextZone.configDpadZoneTvCorpLogin.dYMin;
      case DpadZoneType.MAIN:
        return parmaGetNextZone.configDpadZoneMain.dYMin;
      default: return -1;
    }
  }

  public static getNextZoneBottom = (parmaGetNextZone: ParmaGetNextZone): number => {
    switch (parmaGetNextZone.currentZoneType) {
      case DpadZoneType.HEADER:
        return parmaGetNextZone.configDpadZoneHeader.dYMax;
      case DpadZoneType.SUB_HEADER:
        return parmaGetNextZone.configDpadZoneSubHeader.dYMax;
      case DpadZoneType.MEMU:
        return parmaGetNextZone.configDpadZoneMenu.dYMax;
      case DpadZoneType.LOG_IN:
        return parmaGetNextZone.configDpadZoneLogin.dYMax;
      case DpadZoneType.SCREEN:
        return parmaGetNextZone.configDpadZoneScreen.dYMax;
      case DpadZoneType.TV_LAYOUT:
        return parmaGetNextZone.configDpadZoneTvLayout.dYMax;
      case DpadZoneType.TV_USER_SETTINGS_MID:
        return parmaGetNextZone.configDpadZoneTvUserSettingsMid.dYMax;
      case DpadZoneType.TV_USER_SETTINGS_RIGHT:
        return parmaGetNextZone.configDpadZoneTvUserSettingsRight.dYMax;
      case DpadZoneType.TV_CORP_LOGIN:
        return parmaGetNextZone.configDpadZoneTvCorpLogin.dYMax;
      case DpadZoneType.MAIN:
        return parmaGetNextZone.configDpadZoneMain.dYMax;
      default: return -1;
    }
  }

  public static getNextZoneLeft = (parmaGetNextZone: ParmaGetNextZone): number => {
    switch (parmaGetNextZone.currentZoneType){
      case DpadZoneType.HEADER:
        return parmaGetNextZone.configDpadZoneMenu.dXMin;
      case DpadZoneType.SUB_HEADER:
        return parmaGetNextZone.configDpadZoneSubHeader.dXMin;
      case DpadZoneType.MEMU:
        return parmaGetNextZone.configDpadZoneMenu.dXMin;
      case DpadZoneType.LOG_IN:
        return parmaGetNextZone.configDpadZoneLogin.dXMin;
      case DpadZoneType.SCREEN:
        return parmaGetNextZone.configDpadZoneScreen.dXMin;
      case DpadZoneType.TV_LAYOUT:
        return parmaGetNextZone.configDpadZoneTvLayout.dXMin;
      case DpadZoneType.TV_USER_SETTINGS_MID:
        return parmaGetNextZone.configDpadZoneTvUserSettingsMid.dXMin;
      case DpadZoneType.TV_USER_SETTINGS_RIGHT:
        return parmaGetNextZone.configDpadZoneTvUserSettingsRight.dXMin;
      case DpadZoneType.TV_USER_DB:
        return parmaGetNextZone.configDpadZoneUserDashBoard.dXMin;
      case DpadZoneType.TV_CORP_LOGIN:
        return parmaGetNextZone.configDpadZoneTvCorpLogin.dXMin;
      case DpadZoneType.MAIN:
        return parmaGetNextZone.configDpadZoneMain.dXMin;
      default: return -1;
    }
  }

  public static getNextZoneRight = (parmaGetNextZone: ParmaGetNextZone): number => {
    switch (parmaGetNextZone.currentZoneType){
      case DpadZoneType.HEADER:
        return parmaGetNextZone.configDpadZoneHeader.dXMax;
      case DpadZoneType.SUB_HEADER:
        return parmaGetNextZone.configDpadZoneSubHeader.dXMax;
      case DpadZoneType.MEMU:
        return parmaGetNextZone.configDpadZoneMenu.dXMax;
      case DpadZoneType.LOG_IN:
        return parmaGetNextZone.configDpadZoneLogin.dXMax;
      case DpadZoneType.SCREEN:
        return parmaGetNextZone.configDpadZoneScreen.dXMax;
      case DpadZoneType.TV_LAYOUT:
        return parmaGetNextZone.configDpadZoneTvLayout.dXMax;
      case DpadZoneType.TV_USER_SETTINGS_MID:
        return parmaGetNextZone.configDpadZoneTvUserSettingsMid.dXMax;
      case DpadZoneType.TV_USER_SETTINGS_RIGHT:
        return parmaGetNextZone.configDpadZoneTvUserSettingsRight.dXMax;
      case DpadZoneType.TV_CORP_LOGIN:
        return parmaGetNextZone.configDpadZoneTvCorpLogin.dXMax;
      case DpadZoneType.MAIN:
        return parmaGetNextZone.configDpadZoneMain.dXMax;
      default: return -1;
    }
  }

  public static getNextZone = (parmaGetNextZone: ParmaGetNextZone): number => {
    switch (parmaGetNextZone.dpadDirection) {
      case DpadDirection.UP:
        return DpadHelper.getNextZoneTop(parmaGetNextZone)
      case DpadDirection.DOWN:
        return DpadHelper.getNextZoneBottom(parmaGetNextZone)
      case DpadDirection.LEFT:
        return DpadHelper.getNextZoneLeft(parmaGetNextZone)
      case DpadDirection.RIGHT:
        return DpadHelper.getNextZoneRight(parmaGetNextZone)
      default:
        return -1;
    }
  }


  public static getMaxItemY = (lstIndexDpad: { [key: string]: number[] }): number => {
    if (Object.keys(lstIndexDpad).length === 0) return -1;
    let maxKey = Math.max(...Object.keys(lstIndexDpad).map(k => parseInt(k)));
    return maxKey;
  }

  public static getMinItemY = (lstIndexDpad: any): number => {
    if (Object.keys(lstIndexDpad).length === 0) return -1;
    let minkey = Math.min(...Object.keys(lstIndexDpad).map(k => parseInt(k)));
    return minkey;
  }

  public static getMaxItemX = (lstIndexDpad: any, indexY: number) => {
    if (Object.keys(lstIndexDpad).length === 0) return -1;
    if (!lstIndexDpad[indexY.toString()]) return -1;
    let items = lstIndexDpad[indexY.toString()];
    let maxItem = Math.max(...items.map((k: any) => parseInt(k)));
    return maxItem;
  }

  public static getMinItemX = (lstIndexDpad: any, indexY: number): number => {
    if (Object.keys(lstIndexDpad).length === 0) return -1;
    if (!lstIndexDpad[indexY.toString()]) return -1;
    let items = lstIndexDpad[indexY.toString()];
    let minItem = Math.min(...items.map((k: any) => parseInt(k)));
    return minItem;
  }

  public static getLstIndexDpad = (listItemDpad: NodeListOf<Element>): { [key: string]: number[] } => {
    let lstIndexDpad: { [key: string]: number[] } = {}
    listItemDpad.forEach((itemDpad: any) => {
      let xDpad = itemDpad.getAttribute('x-dpad');
      let yDpad = itemDpad.getAttribute('y-dpad');
      if (!lstIndexDpad[yDpad]) lstIndexDpad[yDpad] = [];

      lstIndexDpad[yDpad].push(xDpad);
      lstIndexDpad[yDpad].sort((indexA: any, indexB: any) => indexB - indexB);
    })
    return lstIndexDpad
  }


  public static getLstIndexTabDpad = (listItemDpad: NodeListOf<Element>): { [key: string]: number[] } => {
    let lstIndexDpad: { [key: string]: number[] } = {}
    listItemDpad.forEach((itemDpad: any) => {
      let xDpad = itemDpad.getAttribute('x-tab-dpad');
      let yDpad = itemDpad.getAttribute('y-tab-dpad');
      if (!lstIndexDpad[yDpad]) lstIndexDpad[yDpad] = [];

      lstIndexDpad[yDpad].push(xDpad);
      lstIndexDpad[yDpad].sort((indexA: any, indexB: any) => indexB - indexB);
    })
    return lstIndexDpad
  }
}
